import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import ARAgeingReportSearchParams from './ARAgeingReportSearchParams';

export default class ARAgeingReportWindowDescription {
  static titleForCreate = 'Export AR Ageing Detail Report';
  static titleForEdit = 'Export AR Ageing Detail Report';
  static itemType = ARAgeingReportSearchParams;
  static serviceFunction = ReportRunnerService.RequestARAgeingReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeIds',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeOrGroupMultiSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CurrencyType',
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ARAgeingReportWindowDescription.currencyTypeValues(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static currencyTypeValues() {
    return [
      { label: 'Invoice Currency', value: 'InvoiceCurrency' },
      { label: 'Office Currency', value: 'OfficeCurrency' },
    ];
  }
}
